import axios from 'axios';

import { getStoredAuthToken } from './authToken';
import { pingSessionActivity } from './sessionTimeout';
import i18next from 'i18next';
import toast from 'react-hot-toast';

const api = axios.create({
  baseURL: `${import.meta.env.REACT_APP_API_BASE_URL}/api` || 'https://dev-app.smsreflex.com/api',
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'Access-Control-Allow-Origin': '*',
  },
});

api.interceptors.request.use((config) => {
  try{
    const access_token = getStoredAuthToken();
    if (access_token && config.headers) config.headers['Authorization'] = `Bearer ${access_token}`;
    config.headers['Accept-Language'] = i18next.language.includes('fr') ? 'fr' : 'en';
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  }catch(err){
     console.log(err);
  }
});

api.interceptors.response.use(({ data }) => {
  // Each successful API response counts as user activity → reset the
  // inactivity timer. The timer itself is owned by sessionTimeout.js
  // (started/stopped by the AppShell).
  pingSessionActivity();
  return data;
}, (error) => {
  // Sans ce gestionnaire, une API momentanément indisponible (redéploiement,
  // redémarrage du conteneur) se traduisait par des écrans vides et muets :
  // chaque page échouait dans son coin sans rien afficher. On ne traite ici
  // que l'indisponibilité du serveur — les 4xx restent l'affaire de l'appelant,
  // et le 401 son propre chemin de déconnexion.
  const status = error?.response?.status;
  const unreachable = !error?.response && error?.code !== 'ERR_CANCELED';
  if (unreachable || status === 502 || status === 503 || status === 504) {
    toast.error(
      i18next.t('ERRORS.SERVER_UNAVAILABLE') ||
        'Serveur momentanément indisponible, réessayez dans un instant.',
      { id: 'server-unavailable' },
    );
  }
  return Promise.reject(error);
});

export default api;